import { useEffect } from 'react';
import { useForm, useFormState  } from 'react-final-form';

function ChangedCoefficientDetector() {
  const { change } = useForm();
  const formState = useFormState();

  useEffect(() => {
      let sum=0;
      for (const property in formState.values.coefficient_def) {
        console.log(`${formState.values.coefficient_def[property].value}`);
        sum+=formState.values.coefficient_def[property].value;
      }
      change('coeficient', sum/100);
  }, [formState.values.coefficient_def]);

  return null;
}

export default ChangedCoefficientDetector;